/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Automation_EmptyInputs */

const cs_settings_automation_empty = /** @type {(inputs: Settings_Automation_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné workflows.`)
};

const en_settings_automation_empty = /** @type {(inputs: Settings_Automation_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No workflows.`)
};

/**
* | output |
* | --- |
* | "No workflows." |
*
* @param {Settings_Automation_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_automation_empty = /** @type {((inputs?: Settings_Automation_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Automation_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_automation_empty(inputs)
	return cs_settings_automation_empty(inputs)
});